import React, {Component, useState, useEffect} from 'react';
import 'leaflet/dist/leaflet.css';
import {Segmentation} from './Segmentation';
import axios from 'axios';
import DemographicInfo from './DemographicInfo';
import {SidebarMainLocations} from './ui_components/sidebarMainLocations'
import {MapMainFindings} from './ui_components/MapMainFindings'
import {SidebarMainHousing} from './ui_components/sidebarMainHousing'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
// import {Maptaskmanagement} from './map_task_manager';
// import { saveAs } from 'file-saver';
import {Loader_sidebar} from './loader_sidebar'
import {ExportDetails} from './ui_components/ExportDetails.js'
import {Commercial_estate} from './commercial_realestate.js'
import DemographicInternational from './ui_components/DemographicInternational'
import PsychographicInternational from './ui_components/PsychographicInternational'
import {LocationSidebarFocused} from './ui_components/locationSidebarFocused'
import maptize from './Images/maptize-black.png';

export const Sidebar_left = (props) => {
  const [state, setState] = useState({
    search: [],
    squareclicked: 'none',
    showresult: 'none',
    industryclicked: false,
    filter: null,
    fss: true,
    cluster: true,
    question: 'none',
    taskmanagement: true,
    showManagementBool: true,
    percent_diff: null,
    color_percentdiff: null,
    arrangement: [],
    hidesidebar: false,
    zoom: 4
  });
  const [filteredSegmentation, setFilteredSegmentation] = useState([]);

  const [exportInProgress, setExportInProgress] = useState(false);
  const [selectedAges, setSelectedAges] = useState([]);
  const [selectedIncome, setSelectedIncome] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
   

  // Equivalent to componentDidMount and componentDidUpdate for taskmanager prop
  useEffect(() => {
    if (props.taskmanager) {
      setState(prevState => ({ ...prevState, taskmanagement: props.taskmanager, showManagementBool: props.taskmanager }));
      props.resettaskmanager();
    }
  }, [props.taskmanager]);

  useEffect(() => {
    if(props.mapLocationClicked?.custom){
      return setState(prevState => ({...prevState,idvalue: props.mapLocationClicked, showManagementBool: true}))
    }
    if(props.mapLocationClicked) {
      showManagementMapping(props.mapLocationClicked, true)
    }else{
      setState(prevState => ({...prevState,idvalue: {}, showManagementBool: true}))
    }
  }, [props.mapLocationClicked])

  // Equivalent to componentDidMount
  useEffect(() => {
    let sidebarstate = localStorage.getItem("statesidebar");
    if (sidebarstate != null && sidebarstate !== 'null')
      setState(prevState => ({ ...prevState, filter: sidebarstate }));

    getstartvalues();
  }, []);

    
    const industry_showmore = () =>  {
      if(props.family)
      setState(prevState => ({ ...prevState, industryclicked: false, zoom: 1, taskmanagement:true}));
    }
    const industry_back = () => {
      setState(prevState => ({ ...prevState, industryclicked: false}));
    }
    const industry_clicked = () => {
      setState(prevState => ({ ...prevState, industryclicked: true}))
    }
    const industry_hidemore = () => {
      if(props.degree)
      setState(prevState => ({ ...prevState, industryclicked: false, zoom: 0, taskmanagement:true}));
    }

    const housing_tab = () => {
      if(props.housing_buy)
      setState(prevState => ({ ...prevState, zoom: 3, taskmanagement:true}))
    }

    const closeFindingLocation = () => {
      if(exportInProgress) return alert('Export In Progress');
      setState(prevState => ({...prevState, taskmanagement:true, showManagementBool: true}))
    }

    const filtersetter = (e) => {
      localStorage.setItem("statesidebar", e)
      setState(prevState => ({ ...prevState, filter: e}))
    }

    
    const showManagementMapping = async (e, mapClicked) => {
      if(!mapClicked) props.getcirclerange(e.name)
      const data_circle = await props.getCircleData(e.name);
      e['data_circle'] = data_circle
      setState(prevState => ({ ...prevState, showManagementBool:false, idvalue: {...e}}))
    }
    
    const setarrangement = async (num) => {
      let token = localStorage.getItem("auth-token");
      console.log(num, 'num')
      let arr = state.arrangement;
      arr.push(num)
      setState(prevState => ({ ...prevState, arrangement: arr}));
      axios.post('/updatearrangement', {arrangement: arr}, {headers:{ "auth-token": token}});
      
    }
    const unsetarrangement = async (num) => {
      let token = localStorage.getItem("auth-token");
      console.log(num, 'num', state.arrangement)
      let arr = state.arrangement;
      let r = arr.filter((e) => {
        if(num != e) return e})
      setState(prevState => ({ ...prevState, arrangement: r}));
      axios.post('/updatearrangement', {arrangement: r}, {headers:{ "auth-token": token}});
    }
    const getstartvalues = async () => {
      let token = localStorage.getItem("auth-token");
      let arrangement_vals = null;
      try{
      let arr = await axios.post('/arrangement', {}, {headers:{ "auth-token": token}});
      arrangement_vals = await arr.data.arrangement;
      }catch(e){
        if(!e.response){
          return window.location.href = "/login";
        }
        if(e.response.status === 400) 
        {
          localStorage.removeItem("auth-token")
          window.location.href = "/login";
         }
      }
      if(arrangement_vals == null)
      // window.location.href = "/setup";
      console.log(arrangement_vals, 'arr values')
      setState(prevState => ({ ...prevState, arrangement: arrangement_vals}))
    }

    const showlocations = () => {
      if(state.zoom !== 4)
      setState(prevState => ({ ...prevState, zoom: 4}))
    }



    const exportData = async () => {
      if(exportInProgress) return;
      setExportInProgress(true);
      props.parentExportInProgress(true);
      
      try {
        // Define sections
        const sections = [
          { id: 'pdf-export-container-details', name: 'Location Details' },
          { id: 'demographic-section', name: 'Demographics' },
          { id: 'segmentation-section', name: 'Segmentation' },
          { id: 'commercial-estate-section', name: 'Commercial Real Estate' },
          { id: 'pdf-export-container-housing', name: 'Residential Real Estate' }
        ];
        
        // Create PDF document
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'pt',
          format: 'a4'
        });
        
        // PDF dimensions
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const headerHeight = 70;
        const margin = 40;
        const contentWidth = pdfWidth - (margin * 2);
        
        // Get location name
        const locationName = state.idvalue.name ? state.idvalue.name : state.idvalue.brand;
        
        // Create temporary img element to load the logo
        const logoImg = new Image();
        logoImg.src = maptize;
        
        // Wait for the logo to load
        await new Promise(resolve => {
          logoImg.onload = resolve;
          // If image fails to load, resolve anyway after a timeout
          setTimeout(resolve, 1000);
        });
        
        // Function to add header to each page
        const addHeader = () => {
          // Add logo
          pdf.addImage(logoImg, 'PNG', margin, 20, 90, 30);
          
          // Add location name
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(12);
          pdf.text(`Address: ${state.idvalue.address}`, pdfWidth - margin - 300, 45);
          
          // Add page divider
          pdf.setDrawColor(200, 200, 200);
          pdf.line(margin, headerHeight - 10, pdfWidth - margin, headerHeight - 10);
          
          // Reset text settings
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(10);
        };
        
        let currentPage = 1;
        
        // Process each section - each starting on a new page
        for (let i = 0; i < sections.length; i++) {
          const section = sections[i];
          const sectionElement = document.getElementById(section.id);
          if (!sectionElement) {
            console.log(`Section element not found: ${section.id}`);
            continue;
          }
          
          // Each section starts on a new page (except the first one)
          if (i > 0) {
            pdf.addPage();
            currentPage++;
          }
          
          // Add bookmark for this section
          pdf.outline.add(null, section.name, { pageNumber: currentPage });
          
          // Add header to the page
          addHeader();
          
          // Initial Y position after header
          let currentY = headerHeight + margin;
          
          // Get all charts and components within the section
          const components = Array.from(sectionElement.querySelectorAll('.chart-component, .data-component'));
          const componentsToProcess = components.length > 0 ? components : [sectionElement];
          
          // Process each component
          for (const component of componentsToProcess) {
            try {
              // Make sure component is visible and has dimensions
              if (!component.offsetParent) {
                console.log('Component is not visible, skipping:', component);
                continue;
              }
              
              // Check if component has width and height
              const rect = component.getBoundingClientRect();
              if (rect.width <= 0 || rect.height <= 0) {
                console.log('Component has zero width or height, skipping:', component, rect);
                continue;
              }
              
              // Render component to canvas using html2canvas
              const tempCanvas = await html2canvas(component, { 
                scale: 2,
                logging: true,
                useCORS: true,
                allowTaint: true
              });
              
              // Verify the canvas has dimensions
              if (tempCanvas.width <= 0 || tempCanvas.height <= 0) {
                console.log('HTML2Canvas returned a canvas with zero dimensions:', tempCanvas);
                continue;
              }
              
              // Get the image data directly from the tempCanvas
              const imgData = tempCanvas.toDataURL('image/png');
              
              // Calculate dimensions while maintaining aspect ratio
              const imgWidth = contentWidth;
              const imgHeight = (tempCanvas.height * imgWidth) / tempCanvas.width;
              
              // Check if component fits on current page
              if (currentY + imgHeight > pdfHeight - margin) {
                // Component doesn't fit, add new page
                pdf.addPage();
                currentPage++;
                addHeader();
                currentY = headerHeight + margin;
              }
              
              // Add component image
              pdf.addImage(imgData, 'PNG', margin, currentY, imgWidth, imgHeight);
              currentY += imgHeight + 20; // Add spacing between components
            } catch (compError) {
              console.error('Error processing component:', compError);
              // Continue with next component
            }
          }
        }
        
        // Save the PDF
        pdf.save(`mapchise_${locationName}.pdf`);
        
      } catch (error) {
        console.error('PDF export error:', error);
        alert('Error exporting PDF. Please try again.');
      } finally {
        setExportInProgress(false);
        props.parentExportInProgress(false);
      }
    };

    const addOpacityToColor = (color, opacity = 0.05) => {
      // Check if the input is a string
      if (typeof color !== 'string') {
          return color;
        }
        
        // Regex to match RGB format: rgb(255, 0, 0) or rgb(255,0,0)
        const rgbRegex = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i;
        
        // Regex to match HEX format: #FFF or #FFFFFF
        const hexRegex = /^#([a-f\d]{3,4}|[a-f\d]{6}|[a-f\d]{8})$/i;
        
        // Check if the string matches RGB format
        const rgbMatch = color.match(rgbRegex);
        
        if (rgbMatch) {
          // Extract the RGB values
          const red = rgbMatch[1];
          const green = rgbMatch[2];
          const blue = rgbMatch[3];
          
          // Return RGBA with the specified opacity
          return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
        }
        
        // Check if the string matches HEX format
        const hexMatch = color.match(hexRegex);
        
        if (hexMatch) {
          let hex = hexMatch[1];
          
          // Convert shorthand hex (#FFF) to full form (#FFFFFF)
          if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
          }
          
          // Parse the hex values to RGB
          const red = parseInt(hex.substring(0, 2), 16);
          const green = parseInt(hex.substring(2, 4), 16);
          const blue = parseInt(hex.substring(4, 6), 16);
          
          // Return RGBA with the specified opacity
          return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
        }
        
        // If it's not an RGB or HEX value, return the original
        return color;
    }

    
    useEffect(() => {
      segmentationApplyFilters();
    }, [selectedAges, selectedIncome, selectedRegion, props.segmentation]);
  
    const segmentationApplyFilters = () => {
      console.log('props.segmentation: ', props.segmentation)
      
      const segmentMap = props.segmentation.segmentMap ? props.segmentation.segmentMap : [];
      let filtered = [...segmentMap];
      filtered = filtered.filter(item => item.age_group !== 'under_18');

      // If selections exist, filter by them, otherwise show all data
      if (selectedAges.length > 0) {
        const ageValues = selectedAges.map(age => age.value);
        if (ageValues.includes('under_18')) {
          // Get all under_18 records that match the other filters
          const under18Items = segmentMap.filter(item => 
            item.age_group === 'under_18' &&
            (selectedIncome.length === 0 || selectedIncome.map(i => i.value).includes(item.income_group)) &&
            (selectedRegion.length === 0 || selectedRegion.map(r => r.value).includes(item.region_type))
          );
          
          // Filter the rest by age
          const otherAgeItems = filtered.filter(item => 
            ageValues.includes(item.age_group)
          );
          
          // Combine both
          filtered = [...under18Items, ...otherAgeItems];
        } else {
          // Just filter by the selected ages (which won't include 'under_18')
          filtered = filtered.filter(item => ageValues.includes(item.age_group));
        }
      }
      
      if (selectedIncome.length > 0) {
        const incomeValues = selectedIncome.map(income => income.value);
        filtered = filtered.filter(item => incomeValues.includes(item.income_group));
      }
      
      if (selectedRegion.length > 0) {
        const regionValues = selectedRegion.map(region => region.value);
        filtered = filtered.filter(item => regionValues.includes(item.region_type));
      }
      filtered = filtered
      .sort((a, b) => b.total_pop - a.total_pop)
      .slice(0, 10);
      // console.log('filtered: ', filtered)
      setFilteredSegmentation(filtered);
    };
    const handleAgeChange = (newValues) => {
      setSelectedAges(newValues);
    };
  
    const handleIncomeChange = (newValues) => {
      setSelectedIncome(newValues);
    };
  
    const handleRegionChange = (newValues) => {
      setSelectedRegion(newValues);
    };
    // Psychograph_updated = () =>{ setState(prevState => ({ ...prevState, Psychograph_updated: false})}
      // console.log('props.getlocations; ', props.getlocations.status_colors, props.mapLocationClicked)
      
      return (
        <div id="sidebar-top">
      {/* {(state.hidesidebar)?<div className="sidebar-closed" onClick={() => setState(prevState => ({ ...prevState, hidesidebar: true})}><div className="fa fa-angle-left"></div></div>:null} */}
        <div>
      <div className={(!state.hidesidebar)?"sidebar-total":"sidebar-total sidebar-total-hide"}>
        <div className={!state.hidesidebar?"sidebar-open": "sidebar-close"} onClick={() => {props.hidesidebar(); setState(prevState => ({ ...prevState, hidesidebar: !state.hidesidebar}))}}><div className="toggle-arrow">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{ transform: !state.hidesidebar ? 'rotate(0deg)' : 'rotate(180deg)' }}
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div></div>
      


      <div id="sidebar-scroll">
        { exportInProgress &&
          <div>
            <div id="pdf-export-container">
              <div id="pdf-export-container-details" className='pt-20'>
                <ExportDetails freetier={props.freetier} showManagementBool={state.showManagementBool} idvalue={state.idvalue}/>
              </div>
              
              <div id="demographic-section">
                {props.municipality_data ? 
                  <DemographicInternational municipality_data={props.municipality_data}/> : 
                  <DemographicInfo exportInd state={state} props={props} industry_hidemore={industry_hidemore} unsetarrangement={unsetarrangement} setarrangement={setarrangement}/>
                }
              </div>
              
              <div id="segmentation-section">
                {props.municipality_data ? 
                  <PsychographicInternational municipality_data={props.municipality_data} /> : 
                  <Segmentation premiumFeatureClicked={props.premiumFeatureClicked} exportInd selectedAges={selectedAges} selectedIncome={selectedIncome} selectedRegion={selectedRegion} onAgeChange={handleAgeChange} onIncomeChange={handleIncomeChange} onRegionChange={handleRegionChange} segmentationClicked={props.segmentationClicked} loading={props.type} segmentation={filteredSegmentation} />
                }
              </div>
              
              <div id="commercial-estate-section">
                <Commercial_estate exportInd commercial_data={props.commercial_data} industrygroup={props.industrygroup}/>
              </div>
              
              <div id="pdf-export-container-housing" className='pt-20'>
                <SidebarMainHousing exportInd housing_seasonality={props.housing_seasonality} housing_buy={props.housing_buy} housing_rent={props.housing_rent} type_industry={props.type_industry}/>
              </div>
            </div>
          </div>
         } 

          {/* if the show more for a selection is clicked */}
        <div id="sidebar-total-desc" data-tut="reactour__data"><div className={(state.zoom == 4)? "topbar-total-each-selected topbar-total-each":"topbar-total-each"} onClick={showlocations}>Business Locations</div>
        <div className={(state.zoom == 0)? "topbar-total-each-selected topbar-total-each":"topbar-total-each"} onClick={industry_hidemore}>Demographic Information</div>
        <div className={(state.zoom == 6)? "topbar-total-each-selected topbar-total-each":"topbar-total-each"} onClick={() => {if(props.freetier && !props.demo) props.premiumFeatureClicked('market_segmentation'); if(props.demo || !props.freetier) setState(prevState => ({ ...prevState, zoom: 6}))}}>Market Segmentation {props.freetier && !props.demo && <div className="fa fa-lock Layer-filter-lock-freetier-sidebar" ></div>}</div>
        <div className={(state.zoom == 1)? "topbar-total-each-selected topbar-total-each":"topbar-total-each"} onClick={() => {(props.freetier) ? props.premiumFeatureClicked('commercial_estate') : industry_showmore()}}>Commercial Real Estate {props.freetier && <div className="fa fa-lock Layer-filter-lock-freetier-sidebar1" ></div>}</div>
        <div className={(state.zoom == 3)? "topbar-total-each-selected topbar-total-each":"topbar-total-each"} onClick={housing_tab}>Housing Real Estate</div></div>
        
          {(props.mapLocationClicked) && <LocationSidebarFocused  getlocations={props.getlocations} mapLocationClicked={props.mapLocationClicked} unSelectLocation={props.unSelectLocation} addOpacityToColor={addOpacityToColor} />}
          {(state.zoom == 6) && ( props.municipality_data ? <PsychographicInternational municipality_data={props.municipality_data} /> : <Segmentation premiumFeatureClicked={props.premiumFeatureClicked} demo={props.demo} selectedAges={selectedAges} selectedIncome={selectedIncome} selectedRegion={selectedRegion} onAgeChange={handleAgeChange} onIncomeChange={handleIncomeChange} onRegionChange={handleRegionChange} segmentationClicked={props.segmentationClicked} loading={props.type} segmentation={filteredSegmentation}  />)}
            
          {(state.zoom == 4) ?  state.showManagementBool ? <SidebarMainLocations boundingbox={props.boundingbox} mapLocationClicked={props.mapLocationClicked} exportInProgress={exportInProgress} exportData={exportData} addOpacityToColor={addOpacityToColor} checkStatusExpanded={props.checkStatusExpanded} filterMapLocationsFunc={props.filterMapLocationsFunc} filterMapLocations={props.filterMapLocations} passesAllFilters={props.passesAllFilters} status={props.status} brand={props.brand} handleRemoveFilter={props.handleRemoveFilter} handleAddFilter={props.handleAddFilter} locationFilters={props.locationFilters} getlocations={props.getlocations} getprospectsidebar={props.getprospectsidebar} showManagementMapping={showManagementMapping}/>:<MapMainFindings segmentation={props.segmentation} demo={props.demo} exportInProgress={exportInProgress} exportData={exportData} defaultBrand={props.cat_all.brand} sidebarUpdateLocationArea={props.sidebarUpdateLocationArea} getlocationrange={props.getlocationrange} idvalue={state.idvalue} closeFindingLocation={closeFindingLocation} defaultRange={props.defaultRange} Competitor_type={props.Competitor_type} statusList={props.status} defaultTags={props.tags}/>:null}
          {/* : <div><div className="box-price box-showmore" onClick={() => setState(prevState => ({ ...prevState, taskmanagement:true}))}><div id="box-goback">Back</div></div> <Maptaskmanagement idvalue={state.idvalue} all_locations={props.all_locations}/></div>} */}

          {(state.zoom ==0) && ( props.municipality_data ? <DemographicInternational municipality_data={props.municipality_data}/> : <DemographicInfo state={state} props={props} industry_hidemore={industry_hidemore}  unsetarrangement={unsetarrangement} setarrangement={setarrangement}/>)}     
          {((state.zoom==1))&&
            <div>
                <Commercial_estate commercial_data={props.commercial_data} industrygroup={props.industrygroup}/>
            </div>}
          {(state.zoom == 3) && <SidebarMainHousing housing_seasonality={props.housing_seasonality} housing_buy={props.housing_buy} housing_rent={props.housing_rent} type_industry={props.type_industry}/>} 
            </div>
        </div>

          </div>
          
        </div>
        
      )
    
  }


